<template>
  <div>
    <main>
      <div class="container">
        <div id="tabs" class="tabs">
          <nav>
            <ul>
              <li
                title="گزارش رزرو پرواز"
                class="icon-booking"
                :class="{ 'tab-current': tabIndex == 0 }"
                @click="tabIndex = 0"
              >
                <a class="icon-confirmed-report">
                  <span> گزارش رزرو پرواز</span>
                </a>
              </li>
              <li
                title="رزروهای جدید"
                class
                :class="{ 'tab-current': tabIndex == 1 }"
                @click="tabIndex = 1"
              >
                <a class="icon-new-report">
                  <span> رزروهای جدید</span>
                </a>
              </li>

              <li
                title="تائید شده"
                :class="{ 'tab-current': tabIndex == 2 }"
                @click="tabIndex = 2"
              >
                <a class="icon-confirmed-report"> <span> تائید شده</span> </a>
              </li>

              <li
                title="تنظیمات"
                class="icon-booking"
                :class="{ 'tab-current': tabIndex == 3 }"
                @click="tabIndex = 3"
              >
                <a class="icon-setting">
                  <span> تنظیمات</span>
                </a>
              </li>
            </ul>
          </nav>

          <div class="content">
            <FlightReservedReport v-if="tabIndex == 0" />
            <NewReservedReport v-if="tabIndex == 1" />
            <ConfirmedReport v-if="tabIndex == 2" />
            <Setting v-if="tabIndex == 3" />
          </div>
        </div>
        <!-- End tabs -->
      </div>
    </main>
  </div>
</template>

<script>
import FlightReservedReport from "./FlightReservedReport";
import NewReservedReport from "./NewReservedReport";
import ConfirmedReport from "./ConfirmedReport";
import Setting from "./Setting";

export default {
  name: "ProfileContent",
  components: {
    FlightReservedReport,
    NewReservedReport,
    ConfirmedReport,
    Setting,
  },
  data: function () {
    return {
      tabIndex: 0,
    };
  },
};
</script>


